export const SET_MANUAL_CASH = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.manualCash.data = payload
    state.manualCash.lastUpdate = new Date()
  }
}
export const ADD_MANUAL_CASH = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.manualCash.data.find(
        (item) => item.data_referencia === data.data_referencia
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.manualCash.data.push(data)
      }
    })
  }
}
export const SET_MANUAL_CASH_LOADING = (state, payload) => {
  state.manualCash.loading = payload
}
export const SET_REVENUE_BY_AREA = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.revenueByArea.data = payload
    state.revenueByArea.lastUpdate = new Date()
  }
}
export const SET_REVENUE_BY_AREA_LOADING = (state, payload) => {
  state.revenueByArea.loading = payload
}
export const SET_REVENUE_BY_PRODUCT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.revenueByProduct.data = payload
    state.revenueByProduct.lastUpdate = new Date()
  }
}
export const SET_REVENUE_BY_PRODUCT_LOADING = (state, payload) => {
  state.revenueByProduct.loading = payload
}
export const SET_PROFESSIONAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.professional.data = payload
    state.professional.lastUpdate = new Date()
  }
}
export const SET_PROFESSIONAL_LOADING = (state, payload) => {
  state.professional.loading = payload
}

export const SET_PROFESSIONAL_KPIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.professionalKpis.data = payload
    state.professionalKpis.lastUpdate = new Date()
  }
}
export const SET_PROFESSIONAL_KPIS_LOADING = (state, payload) => {
  state.professionalKpis.loading = payload
}

export const SET_DFC = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dfc.data = payload
    state.dfc.lastUpdate = new Date()
  }
}
export const SET_DFC_LOADING = (state, payload) => {
  state.dfc.loading = payload
}

export const SET_REVENUE_AREAS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.revenueAreas.data = payload
    state.revenueAreas.lastUpdate = new Date()
  }
}
export const SET_REVENUE_AREAS_LOADING = (state, payload) => {
  state.revenueAreas.loading = payload
}

export const SET_FILIALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.filials.data = payload
    state.filials.lastUpdate = new Date()
  }
}
export const SET_FILIALS_LOADING = (state, payload) => {
  state.filials.loading = payload
}

export const SET_PROFESSIONAL_DRE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.professionalDre.data = payload
    state.professionalDre.lastUpdate = new Date()
  }
}
export const SET_PROFESSIONAL_DRE_LOADING = (state, payload) => {
  state.professionalDre.loading = payload
}

export const SET_BALANCE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.balance.data = payload
    state.balance.lastUpdate = new Date()
  }
}
export const SET_BALANCE_LOADING = (state, payload) => {
  state.balance.loading = payload
}

export const SET_TEAM = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.team.data = payload
    state.team.lastUpdate = new Date()
  }
}
export const SET_TEAM_LOADING = (state, payload) => {
  state.team.loading = payload
}

export const SET_LAST_UPDATE_REFERENCE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.lastUpdateReference.data = payload
    state.lastUpdateReference.lastUpdate = new Date()
  }
}
export const ADD_LAST_UPDATE_REFERENCE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.lastUpdateReference.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.lastUpdateReference.data.push(data)
      }
    })
  }
}
export const SET_LAST_UPDATE_REFERENCE_LOADING = (state, payload) => {
  state.lastUpdateReference.loading = payload
}

export const SET_COMPARATIVE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.comparative.data = payload
    state.comparative.lastUpdate = new Date()
  }
}
export const ADD_COMPARATIVE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.comparative.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.comparative.data.push(data)
      }
    })
  }
}
export const SET_COMPARATIVE_LOADING = (state, payload) => {
  state.comparative.loading = payload
}

export const SET_FILTERS = (state, payload) => {
  state.filters.data = {
    ...state.filters.data,
    ...payload,
  }
}
export const SET_COMISSION_BPO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.comissionBpo.data = payload
    state.comissionBpo.lastUpdate = new Date()
  }
}
export const ADD_COMISSION_BPO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.comissionBpo.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.comissionBpo.data.push(data)
      }
    })
  }
}
export const SET_COMISSION_BPO_LOADING = (state, payload) => {
  state.comissionBpo.loading = payload
}

export const SET_DRE_VERSION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dreVersion.data = payload
    state.dreVersion.lastUpdate = new Date()
  }
}
export const SET_DRE_VERSION_LOADING = (state, payload) => {
  state.dreVersion.loading = payload
}

export const SET_DRE_COMPARATIVE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dreComparative.data = payload
    state.dreComparative.lastUpdate = new Date()
  }
}
export const SET_DRE_COMPARATIVE_LOADING = (state, payload) => {
  state.dreComparative.loading = payload
}

export const SET_DFC_COMPARATIVE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dfcComparative.data = payload
    state.dfcComparative.lastUpdate = new Date()
  }
}
export const SET_DFC_COMPARATIVE_LOADING = (state, payload) => {
  state.dfcComparative.loading = payload
}

